import Dialog from '@mui/material/Dialog'
import DialogActions from '@mui/material/DialogActions'
import DialogContent from '@mui/material/DialogContent'
import DialogTitle from '@mui/material/DialogTitle'
import { Box } from '@pets-ui/Box/Box'
import { Button } from '@pets-ui/Button/Button'
import { Text } from '@pets-ui/Text/Text'
import { colors } from '@pets-ui/tokens/colors.stylex'
import { type ReactNode, useState } from 'react'
import { useTranslation } from 'react-i18next'
import { useUnBindIdentity } from '../../../hooks/useUnBindIdentity'
import { type UnbindIdentityRequest } from '../../../types/apiRequest'
import { useContextMyAccountDialog } from './Provider/useContextMyAccountDialog'

interface DialogSubscribeLineProps {
  open: boolean
  onClose: () => void
  unbindType: UnbindIdentityRequest['type']
}

export function DialogUnbind(props: DialogSubscribeLineProps) {
  const { t } = useTranslation()
  const { open, onClose, unbindType } = props
  const { showDialogServerError } = useContextMyAccountDialog()
  const [isLoading, setIsLoading] = useState(false)
  const { unbind } = useUnBindIdentity({
    onError: () => {
      onClose()
      showDialogServerError()
    },
  })

  const handleClickConfirm = async () => {
    setIsLoading(true)
    await unbind(unbindType)
  }

  const display: Record<UnbindIdentityRequest['type'], ReactNode> = {
    sms: t('login.phoneNumber'),
    email: t('login.email'),
    line: 'LINE',
    facebook: 'Facebook',
    google: 'Google',
  }

  return (
    <Dialog
      disablePortal
      onClose={onClose}
      open={open}
      fullWidth
      sx={{
        '& .MuiDialog-container': {
          '& .MuiPaper-root': {
            width: '100%',
            maxWidth: '320px',
          },
        },
      }}
    >
      <DialogTitle sx={{ m: 0, p: 2 }}>
        <Box display="flex" alignItems="center" justifyContent="center">
          <Text color={colors.grey900} align="center" variant="h4">{t('login.unBindWithType', { type: display[unbindType] })}</Text>
        </Box>
      </DialogTitle>
      <DialogContent sx={{ p: '8px 16px', display: 'flex', justifyContent: 'center', alignItems: 'center' }}>
        <Text align="center" variant="body">{t('login.unBindDialogContent', { type: display[unbindType] })}</Text>
      </DialogContent>
      <DialogActions sx={{ gap: 1 }}>
        <Button disabled={isLoading} fullWidth variant="outlined" onClick={onClose}>{t('button.cancel')}</Button>
        <Button loading={isLoading} fullWidth onClick={handleClickConfirm}>{t('login.unbind')}</Button>
      </DialogActions>
    </Dialog>
  )
}
